/* eslint-disable no-nested-ternary */
import React, { useState, useRef } from "react";

import { Backdrop } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { RiShareLine } from "react-icons/ri";

import Button, { Color } from "../../Form/Button";
import Modal from "../../Generic/Modal";
import DiagnosticsTestModal from "../DiagnosticsTestModal";
import useVideoContext from "../hooks/useVideoContext/useVideoContext";
import JoinModal from "./JoinModal";
import ShareLinkModal, { ShareLinkModalHandles } from "./ShareLinkModal";
import useStyles from "./styles";

interface Props {
  handleConnectInVideoCall: () => void;
  disableButtons: boolean;
  isConnecting: boolean;
  voiceToken?: string;
  iceServers?: RTCIceServer[];
  open: boolean;
  loading?: boolean;
}

const PreJoinModal = (props: Props) => {
  const {
    disableButtons,
    isConnecting,
    open,
    handleConnectInVideoCall,
    voiceToken,
    iceServers,
    loading,
  } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [openTests, setOpenTests] = useState<boolean>(false);
  const [isSharingLink, setIsSharingLink] = useState<boolean>(false);

  const { task, videoSurvey } = useVideoContext();

  const shareLinkModalRef = useRef<ShareLinkModalHandles>(null);

  const renderIconClose = (event?: any, reason?: "backdropClick" | "escapeKeyDown") => {
    if (isSharingLink) {
      if (reason !== "backdropClick") setIsSharingLink(false);
    } else if (reason !== "backdropClick") window?.top?.close();
  };

  const renderButtonClose = () => {
    if (openTests || isSharingLink) return false;

    return true;
  };

  const renderModalTitle = () => {
    if (openTests) {
      return (
        <Button data-cy="backButton" customColor={Color.INFO} onClick={() => setOpenTests(false)}>
          <MdOutlineKeyboardArrowLeft size={16} className="mr-2" />
          {translate("back")}
        </Button>
      );
    }
    if (isSharingLink) {
      return (
        <div className={classes.sharingTitle}>
          <div className={classes.headerIcon}>
            <RiShareLine size={24} color="#308CDB" />
          </div>
          {translate("share")}
        </div>
      );
    }

    return task ? `${task?.type} #${task?.job.reference ? task?.job?.reference : ""}` : "";
  };

  return (
    <div>
      <Modal
        className={classes.modal}
        open={open}
        handleClose={openTests ? undefined : (event, reason) => renderIconClose(event, reason)}
        title={renderModalTitle()}
        dataCyTitle="joinModalTitle"
        dataCyCloseButton="closeButton"
        showActionButtons={renderButtonClose()}
        actionButtonProps={{
          dataCySave: "joinButton",
          textSave: translate("joinNow"),
          customColorSave: Color.SECONDARY,
          onCancel: () => window?.top?.close(),
          onSave: handleConnectInVideoCall,
          loading: isConnecting || !videoSurvey?.token,
          saveDisabled: !videoSurvey?.token || disableButtons,
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          style: {
            // eslint-disable-next-line global-require
            backgroundImage: `url(${require("../../../assets/img/background_video_survey.png")})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
          },
        }}
      >
        <ShareLinkModal
          ref={shareLinkModalRef}
          link={task?.roomLink || ""}
          taskId={task?.id}
          customer={task?.job?.customer}
        />

        {openTests ? (
          <DiagnosticsTestModal voiceToken={voiceToken} iceServers={iceServers} />
        ) : (
          <JoinModal
            openTests={() => setOpenTests(true)}
            disableButtons={disableButtons}
            openShareLink={() => shareLinkModalRef.current?.open()}
            loading={loading}
          />
        )}
      </Modal>
    </div>
  );
};

export default PreJoinModal;
